<template>
  <v-app>
    <v-content>
      <router-view/>
    </v-content>
    <v-footer app dark class="pa-3">
      <v-spacer/>
      <a href="https://resultam.com" target="_blank" class="footer-link">Resultam &copy; {{thisYear}}</a>
      <v-spacer/>
    </v-footer>
  </v-app>
</template>

<script>
var data = new Date()

export default {
  name: 'App',
  data: () => ({
    thisYear: data.getFullYear(),
    drawer: true,
    items: [
      { title: 'Home', icon: 'home', route: '/' },
      { title: 'Editor front-end', icon: 'code', route: '/editor' }
    ],
  }),
  methods: {

  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Lato');
#app {
  font-family: 'Lato';
}
.footer-link {
  color: inherit;
  text-decoration: none;
}
</style>
